/**
 * Normalises a job from API response so permit/CFI/surveyor fields are always camelCase.
 * Handles both camelCase and snake_case response shapes for surveyor jobs filtering.
 */
export function normaliseJob(raw) {
    return {
        ...raw,
        buildingPermitRequested: raw.buildingPermitRequested ?? raw.building_permit_requested ?? false,
        cfiRequested: raw.cfiRequested ?? raw.cfi_requested ?? false,
        cfiApproved: raw.cfiApproved ?? raw.cfi_approved ?? false,
        surveyorStatus: raw.surveyorStatus ?? raw.surveyor_status ?? undefined,
        buildingPermitRequestedDate: raw.buildingPermitRequestedDate ??
            raw.building_permit_requested_date ??
            null,
        buildingPermitApprovedDate: raw.buildingPermitApprovedDate ??
            raw.building_permit_approved_date ??
            null,
        cfiRequestedDate: raw.cfiRequestedDate ?? raw.cfi_requested_date ?? null,
        cfiApprovedDate: raw.cfiApprovedDate ?? raw.cfi_approved_date ?? null,
        buildingPermitNumber: raw.buildingPermitNumber ?? raw.building_permit_number ?? null,
        cfiNumber: raw.cfiNumber ?? raw.cfi_number ?? null,
        buildingTypes: raw.buildingTypes ?? raw.building_types ?? undefined,
    };
}
/**
 * Builds an UpdateJobDto from a Job (only updatable fields). Use overrides to set
 * the field(s) being updated (e.g. { surveyorStatus: "APPROVED" }).
 */
export function jobToUpdateDto(job, overrides) {
    const dto = {
        contactId: job.contactId ?? undefined,
        title: job.title,
        location: job.location,
        address: job.address ?? undefined,
        description: job.description ?? undefined,
        type: job.type,
        status: job.status,
        scope: job.scope ?? undefined,
        siteId: job.siteId ?? undefined,
        commencementDate: job.commencementDate ?? undefined,
        completionDate: job.completionDate ?? undefined,
        durationDays: job.durationDays ?? undefined,
        delayNumber: job.delayNumber ?? undefined,
        delayReason: job.delayReason ?? undefined,
        scheduledDate: job.scheduledDate ?? undefined,
        startTime: job.startTime ?? undefined,
        endTime: job.endTime ?? undefined,
        buildingSurveyorId: job.buildingSurveyorId ?? undefined,
        buildingPermitRequested: job.buildingPermitRequested,
        buildingPermitApproved: job.buildingPermitApproved,
        buildingPermitNumber: job.buildingPermitNumber ?? undefined,
        buildingPermitRequestedDate: job.buildingPermitRequestedDate ?? undefined,
        buildingPermitApprovedDate: job.buildingPermitApprovedDate ?? undefined,
        surveyorStatus: job.surveyorStatus,
        cfiRequested: job.cfiRequested,
        cfiApproved: job.cfiApproved,
        cfiNumber: job.cfiNumber ?? undefined,
        cfiRequestedDate: job.cfiRequestedDate ?? undefined,
        cfiApprovedDate: job.cfiApprovedDate ?? undefined,
        estimatedCost: job.estimatedCost ?? undefined,
        actualCost: job.actualCost ?? undefined,
        notes: job.notes ?? undefined,
        isAdditionalWork: job.isAdditionalWork,
        complaintNotes: job.complaintnotes ??
            job.complaintNotes ??
            undefined,
        complaintDate: job.complaintdate ??
            job.complaintDate ??
            undefined,
        jobSetupCorrectly: job.jobSetupCorrectly,
        prelimsOnTime: job.prelimsOnTime,
        siteRulesFollowed: job.siteRulesFollowed,
        finalQA: job.finalQA ?? undefined,
    };
    const merged = overrides ? { ...dto, ...overrides } : dto;
    // Once granted/requested, never allow reset to false
    const irreversible = {
        buildingPermitRequested: dto.buildingPermitRequested || merged.buildingPermitRequested,
        buildingPermitApproved: dto.buildingPermitApproved || merged.buildingPermitApproved,
        cfiRequested: dto.cfiRequested || merged.cfiRequested,
        cfiApproved: dto.cfiApproved || merged.cfiApproved,
    };
    return { ...merged, ...irreversible };
}
